// Roles y jerarquía de gestión de cuentas. Replica las reglas de private.svc_authorize_user_action
// solo para decidir qué botones mostrar; el servidor es la autoridad.

export type Role = 'superadmin' | 'operator' | 'technician';

export const ROLE_LABELS: Record<Role, string> = {
  superadmin: 'Administrador',
  operator: 'Operador',
  technician: 'Técnico',
};

export interface Actor {
  id: string;
  role: Role;
}

export interface ManagedUser {
  id: string;
  role: Role;
}

export function isStaff(role: Role): boolean {
  return role === 'superadmin' || role === 'operator';
}

/** Roles que el actor puede crear. */
export function creatableRoles(actor: Actor): Role[] {
  if (actor.role === 'superadmin') return ['technician', 'operator'];
  if (actor.role === 'operator') return ['technician'];
  return [];
}

/** Activar/desactivar y resetear clave siguen la misma regla. */
export function canManageUser(actor: Actor, target: ManagedUser): boolean {
  if (actor.id === target.id || target.role === 'superadmin') return false;
  if (target.role === 'operator') return actor.role === 'superadmin';
  return isStaff(actor.role);
}
